"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = exports.PageNotFound = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _mobxReact = require("mobx-react");

var _ReactStaticPage = require("../../page/ReactStaticPage");

var _reactStatic = require("react-static");

var _class;

var PageNotFound = (0, _mobxReact.observer)(_class =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(PageNotFound, _Component);

  function PageNotFound(props) {
    return _Component.call(this, props) || this;
  }

  var _proto = PageNotFound.prototype;

  _proto.render = function render() {
    return _react.default.createElement(_ReactStaticPage.ReactStaticPage, (0, _extends2.default)({
      title: "Page Not Found"
    }, this.props), _react.default.createElement("p", null, "It appears the page you requested is not here at the moment."), _react.default.createElement("p", null, "Maybe the page has moved, or this is not the right location."));
  };

  return PageNotFound;
}(_react.Component)) || _class;

exports.PageNotFound = PageNotFound;

var _default = (0, _reactStatic.withRouteData)(PageNotFound);

exports.default = _default;